import { hooks } from '../wpHooks/index.js';
import { getWpUrl } from './getWpUrl.js';
export function getWpHostname() {
    const wpUrl = getWpUrl();
    let wpHostname = new URL(wpUrl).hostname;
    wpHostname = hooks.applyFilters('wpHostname', wpHostname, {
        wpUrl,
    });
    return wpHostname;
}
